<template>
  <div
    v-if="message"
    class="alert d-flex"
    :class="type"
  >
    <div
      class="flex-grow-1"
      v-html="message"
    />
    <div
      v-if="cross"
      @click="clearAlert()"
    >
      <font-awesome-icon
        icon="times-circle"
        class="close-icon"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'BaseAlert',
  props: {
    cross: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('alert', ['type', 'message']),
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear',
    }),
  },
  watch: {
    $route() {
      this.clearAlert();
    },
  },
};
</script>
<style scoped>
.alert{
  white-space: pre-line;
}
.close-icon{
  opacity: 1;
  line-height: 0;
  transition: opacity .3s ease;
}
.close-icon:hover {
  opacity: 0.5;
}
</style>
